import { analyzePrivClient } from './api';

// tamanho padrão de uma paginador
const PAGE_SIZE = 20;

/**
 * Representação do Serviço do Analyze (cliente)
 */
export default class AnalyzeService {
  /**
   * recupera os resultados gerais para uma pergunta de uma pesquisa
   */
  generalResults(surveyId, questionId, clientId) {
    const result = analyzePrivClient.get(
      `/pesquisas/${surveyId}/resultados/gerais/consolidados/clientes/${clientId}/perguntas/${questionId}`,
    );
    return result;
  }

  /**
   * recupera os dados de um cruzamento múltiplo baseado em uma configuração
   */
  multiCrossing(configId) {
    this.count += 1;
    const result = analyzePrivClient.get(
      `/pesquisa/resultados/cruzamentos-multiplos/${configId}`,
    );
    return result;
  }

  /**
   * recupera uma lista de alternativas baseado na pergunta, na pesquisa e no cliente
   */
  getAlternativasFromPergunta(clientId, surveyId, questionId) {
    const resourceLocation = `/pesquisas/questionarios/cliente/${clientId}/pesquisa/${surveyId}/pergunta/${questionId}/alternativas`;
    const result = analyzePrivClient.get(resourceLocation);
    return result;
  }

  /**
   * recupera as pesquisas baseado em um tenant
   * com as demais
   */
  fetchSurveysByTenant(tenantId) {
    const result = analyzePrivClient.get(
      `/pesquisas/questionarios/${tenantId}`,
    );
    return result;
  }

  /**
   * recupera as questões de uma pesquisa baseado em um tentant
   */
  uploadCSVFile(tenants, title, type, file, fileType, pesquisaDataInicio, pesquisaDataFinalizacao, onUploadProgress) {
    //
    const formData = new FormData();
    formData.set('clientes', tenants);
    formData.set('titulo', title);
    formData.set('tipoImportacao', type);
    formData.set('tipoArquivoImportacao', fileType);
    formData.append('arquivo', file);
    formData.append('pesquisaDataInicio', pesquisaDataInicio);
    formData.append('pesquisaDataFinalizacao', pesquisaDataFinalizacao);
    //
    const result = analyzePrivClient.post('/pesquisa/importar/', formData, { onUploadProgress });
    //
    return result;
  }

  /**
   * armazena uma configuração de cruzamento múltiplo
   */
  storeMultCrossConfig(customerId, surveyId, title, questionsIds, profiles) {
    // create configuration data
    const configData = {
      descricao: title,
      id_perguntas_cruzadas: questionsIds,
      perfil: {
        caracteristicas: profiles.map((p) => ({
          id_pergunta: p.questionId,
          id_alternativa: p.answerId,
        })),
      },
    };
    //
    const url = `/pesquisas/${surveyId}/clientes/${customerId}/cruzamentos_multiplos/configuracoes`;
    const result = analyzePrivClient.post(url, configData);
    //
    return result;
  }

  /**
   * armazena uma configuração de cruzamento múltiplo
   */
  updateMultCrossConfig(customerId, surveyId, configId, title, questionsIds, profiles) {
    // create configuration data
    const configData = {
      id: configId,
      descricao: title,
      id_perguntas_cruzadas: questionsIds,
      perfil: {
        caracteristicas: profiles.map((p) => ({
          id_pergunta: p.questionId,
          id_alternativa: p.answerId,
        })),
      },
    };
    //
    const url = `/pesquisas/${surveyId}/clientes/${customerId}/cruzamentos_multiplos/configuracoes`;
    const result = analyzePrivClient.put(url, configData);
    //
    return result;
  }

  /**
   * remove uma configuração de cruzamento múltiplo
   */
  removeMultCrossConfig(customerId, surveyId, configId) {
    const url = `/pesquisa/resultados/cruzamento_multiplo/configuracoes/${configId}`;
    const result = analyzePrivClient.delete(url);
    return result;
  }

  /**
   * lista os dados de configuração de cruzamento múltiplo
   * @param {*} customerId
   * @param {*} surveyId
   */
  listMultCrossConfigs(customerId, surveyId, questionId) {
    const url = `/pesquisas/${surveyId}/clientes/${customerId}/cruzamentos_multiplos/configuracoes/pergunta_principal/${questionId}`;
    const result = analyzePrivClient.get(url);
    return result;
  }

  /**
   * encontrar os dados de configuração de cruzamento múltiplo
   * @param {*} customerId
   * @param {*} surveyId
   */
  findMultCrossConfigs(customerId, surveyId, questionId, configId) {
    const url = `/pesquisa/resultados/cruzamento_multiplo/configuracoes/${configId}`;
    const result = analyzePrivClient.get(url);
    return result;
  }

  /**
   * Armazena dos dados de configuração de correlação
   * @param {*} customerId
   * @param {*} surveyId
   * @param {*} title
   * @param {*} questionsIds
   * @param {*} mainAnswer
   * @param {*} minMaxCorrValue
   */
  storeCorrelationConfig(customerId, surveyId, title, questionsIds, mainAnswer, minMaxCorrValue) {
    // create configuration data
    const configData = {
      titulo: title,
      perguntas_relacionadas: questionsIds,
      resposta_correlacionada: {
        id_pergunta: mainAnswer.questionId,
        id_alternativa: mainAnswer.answerId,
      },
      nota_corte: minMaxCorrValue,
    };
    //
    const url = `/clientes/${customerId}/pesquisas/${surveyId}/correlacao/configuracoes`;
    const result = analyzePrivClient.post(url, configData);
    //
    return result;
  }

  /**
   * Armazena dos dados de configuração de correlação
   * @param {*} customerId
   * @param {*} surveyId
   * @param {*} configId
   * @param {*} title
   * @param {*} questionsIds
   * @param {*} mainAnswer
   * @param {*} minMaxCorrValue
   */
  updateCorrelationConfig(customerId, surveyId, configId, title, questionsIds, mainAnswer, minMaxCorrValue) {
    // create configuration data
    const configData = {
      id: configId,
      titulo: title,
      perguntas_relacionadas: questionsIds,
      resposta_correlacionada: {
        id_pergunta: mainAnswer.questionId,
        id_alternativa: mainAnswer.answerId,
      },
      nota_corte: minMaxCorrValue,
    };
    //
    const url = `/clientes/${customerId}/pesquisas/${surveyId}/correlacao/configuracoes`;
    const result = analyzePrivClient.put(url, configData);
    //
    return result;
  }

  /**
   * remove uma configuração de cruzamento múltiplo
   */
  removeCorrConfig(customerId, surveyId, configId) {
    const url = `/pesquisa/resultados/correlacao/configuracoes/${configId}`;
    const result = analyzePrivClient.delete(url);
    return result;
  }

  // eslint-disable-next-line no-unused-vars
  listCorrelationConfigs(customerId, surveyId, questionId) {
    const url = `/clientes/${customerId}/pesquisas/${surveyId}/correlacao/configuracoes/pergunta_principal/${questionId}`;
    const result = analyzePrivClient.get(url);
    return result;
  }

  // eslint-disable-next-line no-unused-vars
  findCorrelationConfig(customerId, surveyId, questionId, configId) {
    const url = `/pesquisa/resultados/correlacao/configuracoes/${configId}`;
    const result = analyzePrivClient.get(url);
    return result;
  }

  criarConfiguracaoCruzamentoSimples(clientId, surveyId, configuracao) {
    const resourceLocation = `/pesquisas/${surveyId}/clientes/${clientId}/cruzamento_simples/configuracoes`;
    const result = analyzePrivClient.post(resourceLocation, configuracao);
    return result;
  }

  atualizarConfiguracaoCruzamentoSimples(clientId, surveyId, mainQuestionId, configuracao) {
    const resourceLocation = `/pesquisas/${surveyId}/clientes/${clientId}/cruzamento_simples/configuracoes/pergunta_principal/${mainQuestionId}`;
    const result = analyzePrivClient.put(resourceLocation, configuracao);
    return result;
  }

  listSimpleCrossConfig(clientId, surveyId) {
    const resourceLocation = `/pesquisas/${surveyId}/clientes/${clientId}/cruzamento_simples/configuracoes/pergunta_principal`;
    const result = analyzePrivClient.get(resourceLocation);
    return result;
  }

  deleteSimpleCrossConfig(idPesquisa, idCliente, idPerguntaPrincipal) {
    const resourceLocation = `/pesquisas/${idPesquisa}/clientes/${idCliente}/cruzamentos/simples/configuracoes/perguntas/principal/${idPerguntaPrincipal}`;
    const result = analyzePrivClient.delete(resourceLocation);
    return result;
  }

  fetchCrossConfigResult(customerId, surveyId, mainQuestionId) {
    const resourceLocation = `/pesquisa/resultados/cruzamento-simples/cliente/${customerId}/pesquisa/${surveyId}/pergunta/${mainQuestionId}`;
    const result = analyzePrivClient.get(resourceLocation);
    return result;
  }

  storeEvolutiveConfig(customerId, surveyId, questionId, title, othersSurveys, alternativeMatchs) {
    // create configuration data
    const configData = {
      descricao: title,
      mapeamento_pesquisas: {
        pesquisa_principal: {
          id: surveyId,
          id_pergunta: questionId,
        },
        pesquisas_equivalentes: othersSurveys.map((other) => ({
          id: other.surveyId,
          id_pergunta: other.questionId,
        })),
        alternativas: alternativeMatchs,
      },
    };
    //
    const url = `/pesquisas/${surveyId}/clientes/${customerId}/resultados_evolutivos/configuracoes`;
    const result = analyzePrivClient.post(url, configData);
    //
    return result;
  }

  updateEvolutiveConfig(customerId, surveyId, questionId, configId, title, othersSurveys, alternativeMatchs) {
    // create configuration data
    const configData = {
      id: configId,
      descricao: title,
      mapeamento_pesquisas: {
        pesquisa_principal: {
          id: surveyId,
          id_pergunta: questionId,
        },
        pesquisas_equivalentes: othersSurveys.map((other) => ({
          id: other.surveyId,
          id_pergunta: other.questionId,
        })),
        alternativas: alternativeMatchs,
      },
    };
    //
    const url = `/pesquisas/${surveyId}/clientes/${customerId}/resultados_evolutivos/configuracoes`;
    const result = analyzePrivClient.put(url, configData);
    //
    return result;
  }

  findEvolutiveConfig(clientId, surveyId, questionId, configId) {
    const resourceLocation = `/pesquisa/resultados/evolutivo/configuracoes/${configId}`;
    const result = analyzePrivClient.get(resourceLocation);
    return result;
  }

  // eslint-disable-next-line no-unused-vars
  listEvolutiveConfigs(clientId, surveyId, questionId) {
    this.countEv += 1;
    const resourceLocation = `/pesquisas/${surveyId}/clientes/${clientId}/resultados_evolutivos/configuracoes/pergunta_principal/${questionId}`;
    const result = analyzePrivClient.get(resourceLocation);

    return result;
  }

  fetchEvolutiveConfigResult(configId) {
    const resourceLocation = `/pesquisas/resultados_evolutivos/${configId}`;
    const result = analyzePrivClient.get(resourceLocation);
    return result;
  }


  removeEvolutiveConfig(customerId, surveyId, configId) {
    const url = `/pesquisa/resultados/evolutivo/configuracoes/${configId}`;
    const result = analyzePrivClient.delete(url);
    return result;
  }

  storeAutoCorrConfig(customerId, surveyId, minMaxCorrValue) {
    return new Promise((resolve) => {
      const key = `${customerId}.${surveyId}`;
      localStorage.setItem(key, minMaxCorrValue);
      resolve({ data: { minMaxCorrValue }});
    });
  }

  fetchAutoCorrConfig(customerId, surveyId) {
    return new Promise((resolve) => {
      const key = `${customerId}.${surveyId}`;
      const value = localStorage.getItem(key);
      resolve({ data: { minMaxCorrValue: parseFloat(value) }});
    });
  }

  // busca textual
  // [
  //   {
  //     id: number; // identificador da pesquisa. Pode ser nulo caso a pesquisa ainda não tenha sido processada
  //     titulo: string; // titulo da pesquisa importada
  //     ativo: // se a pesquisa está ativa ou não. pode ser nulo caso ainda não tenha sido processada
  //     atendida: // se a solicitação de importação da pesquisa já foi atendida a.k.a. processada ou não.
  //     status: // status indicando o estado atual da "pesquisa". Pode ser: ATIVO, DESATIVO ou NAO_PROCESSADO
  //   }
  // ]
  fetchSurveysByText(customerId, queryText, page = 0, sortIndex = 0, dirIndex = 0) {
    // sorting
    const sortEnum = (sIndex) => {
      const fields = ['titulo', 'atendida', 'ativo'];
      return fields[sIndex] ? fields[sIndex] : 'titulo';
    };
    const directionEnum = (dIndex) => {
      const direction = ['asc', 'desc'];
      return direction[dIndex] ? direction[dIndex] : 'asc';
    };
    const sortBy = `sort=${sortEnum(sortIndex)},${directionEnum(dirIndex)}`;
    // paging
    const paging = `page=${page}&size=${PAGE_SIZE}&`;
    // text
    const query = queryText ? `query=${encodeURIComponent(queryText)}&` : '';
    // build url
    const url = `/pesquisa?${query}${paging}${sortBy}`;
    const result = analyzePrivClient.get(url);
    return result;
  }

  /**
   * `GET: api/v1/pesquisa/paginacao`
   *
   * **query_params:**
   *
   * - page_size [required]: número de pesquisas por página
   * ex: `?page_size=20`
   *
   * - query: termos de busca na qual deseja-se realizar a busca textual, aqui devem ser passados um texto qualquer e as pesquisas que satisfazerem a busca, serão retornadas. ex: `?query=política` ou `?query=pesquisa política`
   *
   * **response format: application/json**
   * **response structure**
   * ```typescript
   * class Payload {
   *   total_results: number; // numero total de pesquisas que satisfazem a consulta
   *   pages_number: number; // numero total de páginas de resultados. O tamanho da página é definido no queryParam "page_size"
   * }
   */
  surveysPages(customerId, queryText) {
    // paging
    const paging = `page_size=${PAGE_SIZE}`;
    // text
    const query = queryText ? `&query=${encodeURIComponent(queryText)}` : '';
    // build url
    const url = `/pesquisa/paginacao?${paging}${query}`;
    const result = analyzePrivClient.get(url);
    return result;
  }

  /**
   * remover uma pesquisa
   */
  removeSurveys(customerId, surveyId) {
    const url = `/pesquisa/${surveyId}`;
    const result = analyzePrivClient.delete(url);
    return result;
  }

  /**
  * PUT: api/v1/pesquisa/{id_pesquisa}`
  *   **request body format: application/json**
  *   **request body stucture**
  *   ```typescript
  *   class Payload {
  *     descricao: string;
  *     compartilhamentos_removidos: number[];
  *     compartilhamentos_atualizados: [
  *       {
  *         id: number;
  *         ativo: boolean;
  *       }
  *     ]
  *   }
  */
  updateSurvey(customerId, surveyId, surveyTitle, surveyInitialDate, surveyEndDate, usersToRemove, activations) {
    const url = `/pesquisa/${surveyId}`;
    const result = analyzePrivClient.put(url, {
      descricao: surveyTitle,
      data_inicio: surveyInitialDate,
      data_finalizacao: surveyEndDate,
      compartilhamentos_removidos: usersToRemove,
      compartilhamentos_atualizados: activations,
    });
    return result;
  }

  /**
   * `POST: api/v1/pesquisa/{id_pesquisa}/visibilidade/{visibilidade}`
   * **onde**:
   * - id_pesquisa: identificador da pesquisa querá sua visibilidade alterada
   * - visibilidade: valor `boolean` indicando se a pesquisa está ativa `true` ou não `false`
   * **response status**
   * - 200: visibilidade alterada com sucesso
   */
  activeSurvey(customerId, surveyId, surveyTitle, active) {
    const url = `/pesquisa/${surveyId}/visibilidade/${active}`;
    const result = analyzePrivClient.post(url);
    return result;
  }

  /**
   * `GET: api/v1/pesquisa/{id_pesquisa}`
   *
   * **response body format: application/json**
   * **response body format**
   * ```typescript
   * class Payload {
   *   id: number;
   *   descricao: string;
   *   compartilhamentos: [
   *     {
   *       id: number; // id do compartilhamento
   *       cliente: number; // id do cliente
   *       ativo: boolean; // se o compartilhamento está ativo ou não
   *       is_principal: boolean; // se este é o compartilhamento principal da pesquisa
   *       // compartilhamentos principais são aqueles criados no momento do registro da pesquisa
   *     }
   *   ]
   * }
   *
   */
  fetchSurveyById(customerId, surveyId) {
    const url = `/pesquisa/${surveyId}`;
    const result = analyzePrivClient.get(url);
    return result;
  }

  /**
   * Alterando a status de check do resultado do cruzamento
   */
  checkResultadoCruzamento(customerId, surveyId, resultadoId, newCheckStatus) {
    const url = `/pesquisa/resultados/cruzamento-simples/marcacao/cliente/${customerId}/pesquisa/${surveyId}/resultado/${resultadoId}/checked/${newCheckStatus}`;
    const result = analyzePrivClient.put(url);
    return result;
  }

  /**
    * compartilhar pesquisa
    *
    * `POST: /pesquisa/{id_pesquisa}/compartilhamento`
    *
    * **request body format: application/json**
    * **request body stucture**
    * ```typescript
    * class Payload {
    *   id_pesquisa: number; // pesquisa compartilhada
    *   novos_clientes: number[]; // clientes para quem a pesquisa está sendo compartilhada
    *   manter_configuracoes: boolean; // se as configurações dos clientes principais desta pesquisa devem ser replicadas ou não para os novos clientes
    * }
    * ```
    *
    * **response body format: application/json**
    * **response body format**
    * ```typescript
    * // devolve uma array de Payload
    * // cada compartilhamento retornado refere-se a o compartilhamento da pesquisa com um cliente
    * class Payload {
    *   id: number; // id do compartilhamento criado
    *   idCliente: number; // id do cliente beneficiado com o compartilhamento
    *   ativo: boolean; // status do compartilhamento, se está ativo ou não.
    * }
    *
    * shareData = {customers:[cids], keepConfig: bool}
    */
  shareSurvey(customerId, surveyId, shareData) {
    // url
    const url = `/pesquisa/${surveyId}/compartilhamento`;
    // data
    const data = {
      id_pesquisa: surveyId,
      novos_clientes: shareData.customers,
      manter_configuracoes: shareData.keepConfig,
    };
    const result = analyzePrivClient.post(url, data);
    return result;
  }

  /**
   * Recupera as anotacoes de determinado resultado
   */
  fetchAnnotations(customerId, surveyId, resultId, resultType) {
    const url = `/pesquisa/resultados/anotacoes/cliente/${customerId}/pesquisa/${surveyId}/resultado/${resultId}`;
    return analyzePrivClient.post(url, { result_type: resultType });
  }

  /**
   * Armazena anotacoes de determinado resultado
   */
  saveAnnotations(customerId, surveyId, resultId, annotation, resultType) {
    const url = `/pesquisa/resultados/anotacoes/cliente/${customerId}/pesquisa/${surveyId}/resultado/${resultId}`;
    const payload = JSON.stringify(annotation);
    return analyzePrivClient.put(url, { content: payload, result_type: resultType });
  }

  getReportPayload(customerId, surveyId) {
    const url = `/pesquisa/resultados/relatorio/cliente/${customerId}/pesquisa/${surveyId}`;
    return analyzePrivClient.get(url);
  }
}
